import { render, staticRenderFns } from "./OnboardingVerificationLink.vue?vue&type=template&id=3b200f96&"
import script from "./OnboardingVerificationLink.vue?vue&type=script&lang=js&"
export * from "./OnboardingVerificationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports